import { initialServicesState } from 'redux/initialState';

import { status } from 'constants/general';
import servicesActionTypes from './action-types';

const servicesReducer = (state = initialServicesState, { type, payload }) => {
  switch (type) {
    case servicesActionTypes.FETCH_SPECIALITIES:
      return {
        ...state,
        specialitiesList: {
          status: status.FETCHING,
        },
      };
    case servicesActionTypes.FETCH_SPECIALITIES_SUCCESS:
      return {
        ...state,
        specialitiesList: {
          status: status.SUCCESS,
          details: payload,
        },
      };
    case servicesActionTypes.FETCH_SPECIALITIES_FAIL:
      return {
        ...state,
        specialitiesList: {
          status: status.FAIL,
        },
      };
    case servicesActionTypes.FETCH_SERVICES_LIST:
      return {
        ...state,
        servicesList: {
          status: status.FETCHING,
        },
      };

    case servicesActionTypes.FETCH_SERVICES_LIST_SUCCESS:
      return {
        ...state,
        servicesList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case servicesActionTypes.FETCH_SERVICES_LIST_FAIL:
      return {
        ...state,
        servicesList: {
          status: status.FAIL,
        },
      };
    case servicesActionTypes.ADD_OR_EDIT_SERVICE:
      return {
        ...state,
        addOrEditService: {
          status: status.FETCHING,
        },
      };
    case servicesActionTypes.ADD_OR_EDIT_SERVICE_SUCCESS:
      return {
        ...state,
        addOrEditService: {
          status: status.SUCCESS,
        },
      };
    case servicesActionTypes.ADD_OR_EDIT_SERVICE_FAIL:
      return {
        ...state,
        addOrEditService: {
          status: status.FAIL,
          error: payload,
        },
      };
    case servicesActionTypes.RESET_ADD_OR_EDIT_SERVICE:
      return {
        ...state,
        addOrEditService: {
          ...initialServicesState.addOrEditService,
        },
      };
    case servicesActionTypes.DELETE_SERVICE:
      return {
        ...state,
        deleteService: {
          status: status.FETCHING,
        },
      };
    case servicesActionTypes.DELETE_SERVICE_SUCCESS:
      return {
        ...state,
        deleteService: {
          status: status.SUCCESS,
        },
      };
    case servicesActionTypes.DELETE_SERVICE_FAIL:
      return {
        ...state,
        deleteService: {
          status: status.FAIL,
        },
      };
    default:
      return state;
  }
};

export default servicesReducer;
